import React from "react";
import { motion } from "framer-motion";

const images = [
  {
    url: "https://images.unsplash.com/photo-1633014041037-f5446fb4ce99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBmb2FtJTIwd2FzaHxlbnwwfHx8fDE3Nzg3OTc3Njl8MA&ixlib=rb-4.1.0&q=85",
    label: "Snow foam · Exterior",
    span: "row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBmb2FtJTIwd2FzaHxlbnwwfHx8fDE3Nzg3OTc3Njl8MA&ixlib=rb-4.1.0&q=85",
    label: "Black luxury · Studio",
    span: "row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBmb2FtJTIwd2FzaHxlbnwwfHx8fDE3Nzg3OTc3Njl8MA&ixlib=rb-4.1.0&q=85",
    label: "Wheel · Deep clean",
    span: "row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1682858110563-3f609263d418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFufGVufDB8fHx8MTc3ODc5Nzc2OXww&ixlib=rb-4.1.0&q=85",
    label: "Leather conditioning",
    span: "row-span-1",
  },
  {
    url: "https://images.unsplash.com/photo-1621639532859-8b26570b96fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFufGVufDB8fHx8MTc3ODc5Nzc2OXww&ixlib=rb-4.1.0&q=85",
    label: "Cockpit · After",
    span: "row-span-1",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="relative bg-[#050505] py-28 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-xl">
            <span className="text-blue-500 uppercase text-xs tracking-[0.3em] font-semibold mb-4 block">
              · 05 The Work
            </span>
            <h2 className="font-heading text-white text-4xl md:text-5xl lg:text-6xl tracking-tighter font-light">
              Cars we've
              <br />
              <span className="font-medium">brought back to life.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md md:text-right">
            A small selection from over 800 details. Every paint correction, every interior. Documented.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {images.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`relative overflow-hidden group cursor-pointer ${img.span} ${
                i === 0 ? "col-span-2 md:col-span-2" : "col-span-1"
              }`}
            >
              <img
                src={img.url}
                alt={img.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-sm font-medium font-heading tracking-wide">
                  {img.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
